import script from "./editable-input-violation.vue?vue&type=script&setup=true&lang=js"
export * from "./editable-input-violation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__